import { useTranslation } from "react-i18next";
import { PermissionsGate } from "../../../../../common/components/PermissionsGate";
import { LOCATION_ROUTES, PERMISSIONS } from "../../../../../common/constants";
import {
    PRODUCTS,
    PRODUCT_MODULES,
} from "../../../../../common/constants/products.constants";
import {
    IconDevices,
    IconEnergy,
    IconLogs,
    IconMonitor,
    IconOccupancies,
    IconSpaces,
} from "../../Icons";
import IconDashboard from "../../Icons/IconDashboard";
import { NavigationButton } from "../NavigationButton";

interface LocationControlProps {
    companyId?: string;
    locationId?: string;
}

const LocationControls = (props: LocationControlProps) => {
    const { companyId, locationId } = props;

    const { t } = useTranslation("common");

    return (
        <div className="flex items-center justify-center flex-col gap-4 mt-2 md:mt-8">
            <NavigationButton
                href={{
                    pathname: LOCATION_ROUTES.DASHBOARD,
                    query: {
                        companyId,
                        locationId,
                    },
                }}
                label={t("dashboard")}
                icon={<IconDashboard />}
            />
            <PermissionsGate
                permissions={[PERMISSIONS.LOCATION.READ]}
                productsToCheck={[
                    {
                        id: PRODUCTS.BETTER_ENERGY,
                        modules: [
                            {
                                id: PRODUCT_MODULES.BETTER_CONTROL,
                            },
                        ],
                    },
                ]}
            >
                <NavigationButton
                    href={{
                        pathname: LOCATION_ROUTES.ENERGY.OVERVIEW,
                        query: {
                            companyId,
                            locationId,
                        },
                    }}
                    label={t("energy")}
                    icon={<IconEnergy />}
                />
            </PermissionsGate>
            <PermissionsGate
                permissions={[PERMISSIONS.ENERGY_MONITOR.READ]}
                productsToCheck={[
                    {
                        id: PRODUCTS.BETTER_ENERGY,
                        modules: [
                            {
                                id: PRODUCT_MODULES.BETTER_MONITOR,
                            },
                        ],
                    },
                ]}
            >
                <NavigationButton
                    href={{
                        pathname: LOCATION_ROUTES.MONITOR,
                        query: {
                            companyId,
                            locationId,
                        },
                    }}
                    label={t("monitor")}
                    icon={<IconMonitor />}
                />
            </PermissionsGate>
            <PermissionsGate permissions={[PERMISSIONS.DEVICE.READ]}>
                <NavigationButton
                    href={{
                        pathname: LOCATION_ROUTES.DEVICES,
                        query: {
                            companyId,
                            locationId,
                        },
                    }}
                    label={t("devices")}
                    icon={<IconDevices />}
                />
            </PermissionsGate>
            <PermissionsGate permissions={[PERMISSIONS.OCCUPANCY.READ]}>
                <NavigationButton
                    href={{
                        pathname: LOCATION_ROUTES.OCCUPANCIES,
                        query: {
                            companyId,
                            locationId,
                        },
                    }}
                    label={t("occupancies")}
                    icon={<IconOccupancies />}
                />
            </PermissionsGate>
            <PermissionsGate permissions={[PERMISSIONS.SPACE.READ]}>
                <NavigationButton
                    href={{
                        pathname: LOCATION_ROUTES.SPACES,
                        query: {
                            companyId,
                            locationId,
                        },
                    }}
                    label={t("spaces")}
                    icon={<IconSpaces />}
                />
            </PermissionsGate>
            <PermissionsGate>
                <NavigationButton
                    href={{
                        pathname: LOCATION_ROUTES.LOGS,
                        query: {
                            companyId,
                            locationId,
                        },
                    }}
                    label={t("logs")}
                    icon={<IconLogs />}
                    className="[&>svg]:ml-2"
                />
            </PermissionsGate>
        </div>
    );
};

export default LocationControls;
